import html2canvas from "html2canvas";
//import { generateFileName } from "./stringUtils";
import { ExportHiddenClass } from "Consts";
import { isNullOrUndefined } from "./objectUtils";

export const pngExportFilter = (node: HTMLElement) => {
  const exclusionClasses = [ExportHiddenClass, "apexcharts-tooltip", "apexcharts-toolbar"];
  return (
    !exclusionClasses.some((className) => node.classList?.contains(className)) ||
    !isNullOrUndefined(node.classList)
  );
};

export const handlePNGExport = async (
  node: HTMLDivElement,
  colorMode: string = "DARK",
  fileName: string | undefined
) => {
  if (isNullOrUndefined(node)) {
    return;
  }
  const wrapper = document.createElement("div");

  wrapper.style.padding = "16px";
  wrapper.style.background = colorMode === "DARK" ? "#111111" : "#fff";
  wrapper.style.display = "inline-block";

  wrapper.appendChild(node.cloneNode(true));

  document.body.appendChild(wrapper);

  const canvas = await html2canvas(wrapper, {
    backgroundColor: colorMode === "DARK" ? "#111111" : "#fff",
    scale: 2,
    useCORS: true,
  });
  wrapper.remove();

  const imgURI = canvas.toDataURL("image/png");

  const link = document.createElement("a");
  link.href = imgURI;
  const _fileName = fileName || "wisdom-chart-download";
  link.download = `${_fileName}-${new Date().valueOf()}.png`;
  link.click();
};
